import { Dialog } from "primereact/dialog";
import { InvoiceSummaryService } from "../InvoiceSummaryService";
import { useEffect } from "react";
import { useDataTable } from "../../../shared/hooks/DataTable";
import { InvoiceSummary, OInvoiceLookUpField } from "../../../shared/constants";
import { FormattedCurrency } from "../../../shared/component/FormattedCurrency";

export const DetailDialog = ({
  open,
  onHide,
  id,
  summaryData,
}: {
  open: boolean;
  onHide: (open: boolean) => void;
  id: string;
  summaryData?: InvoiceSummary | InvoiceSummary[];
}) => {
  const { render: renderDataTable, refreshLazyData } = useDataTable({
    indexColumnWidth: 50,
    selectionMode: "none",
    columns: [
      {
        field: OInvoiceLookUpField.INVOICE_SERIAL,
        header: "Ký hiệu",
        sortable: false,
      },
      {
        field: OInvoiceLookUpField.INVOICE_NUMBER,
        header: "Số hóa đơn",
        sortable: false,
      },
      {
        field: OInvoiceLookUpField.INVOICE_DATE,
        header: "Ngày lập",
        sortable: false,
      },
      {
        field: OInvoiceLookUpField.BUYER_NAME,
        header: "Tên người mua",
        sortable: false,
      },
      {
        field: OInvoiceLookUpField.BUYER_TAX_CODE,
        header: "MST người mua",
        sortable: false,
      },
      {
        field: OInvoiceLookUpField.BUYER_BUDGET_UNIT_CODE,
        header: "Mã đơn vị quan hệ ngân sách",
        sortable: false,
        width: 190,
      },
      {
        field: OInvoiceLookUpField.TOTAL_AMOUNT,
        header: "Tổng tiền thanh toán",
        sortable: false,
        dataType: "custom",
        width: 130,
        customCell: (item) => (
          <FormattedCurrency
            value={item[OInvoiceLookUpField.TOTAL_AMOUNT]}
            currency={!Array.isArray(summaryData) && summaryData.currencyCode}
          />
        ),
      },
    ],
    getList: () => {
      if (!id) {
        return Promise.resolve({
          items: [],
          totalCount: 0,
        });
      }
      return InvoiceSummaryService.getInvoiceSummaryById(id).then((data) => ({
        items: data,
        totalCount: data.length,
      }));
    },
  });

  useEffect(() => {
    if (id) {
      refreshLazyData();
    }
    // add refreshLazyData to deps cause infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <Dialog
      header='Chi tiết bảng tổng hợp'
      visible={open}
      style={{ width: "100%", maxWidth: "1000px" }}
      onHide={() => onHide(false)}
    >
      {renderDataTable()}
    </Dialog>
  );
};
